import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './RootContent.module.css';

const bindClasses = classNameBind.bind(styles);

const RootContent = ({ children }) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="RootContent"
  >
    {children}
  </div>
);

RootContent.displayName = 'Root.Content';

export default RootContent;
